"use client";
import mixpanel from "mixpanel-browser";
import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { env } from "~/env.mjs";

const MIXPANEL_TOKEN = env.NEXT_PUBLIC_MIXPANEL_TOKEN;

export const MixpanelClient = () => {
    const pathname = usePathname();
    const searchParams = useSearchParams();

    useEffect(() => {
        if (!MIXPANEL_TOKEN) {
            console.warn("Mixpanel token is missing! Check your .env file.");
            return;
        }

        mixpanel.init(MIXPANEL_TOKEN, {
            track_pageview: true,
            autotrack: true,
        });
    }, []);

    useEffect(() => {
        if (!pathname || !mixpanel || !MIXPANEL_TOKEN) return;

        // Construct the full URL including search params
        const url = searchParams?.toString()
            ? `${pathname}?${searchParams.toString()}`
            : pathname;
        mixpanel.track("Page View", { page: url });
    }, [pathname, searchParams]);

    return null;
};
